import initializeAuthentication from "../Firebase/firebase.init";
import { getAuth, createUserWithEmailAndPassword, updateProfile, GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword, onAuthStateChanged, signOut, getIdToken } from "firebase/auth";
import { useState, useEffect } from "react";
import swal from 'sweetalert';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { getStorage } from "firebase/storage";



initializeAuthentication();
toast.configure();

const useFirebase = () => {
    const storage = getStorage(initializeAuthentication());
    const [user, setUser] = useState({});
    const [admin, setAdmin] = useState(false);
    const [userLoading, setUserLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const googleProvider = new GoogleAuthProvider();

    const auth = getAuth();
    const navigate = useNavigate();


    const registerUser = (name, email, password) => {
        setIsLoading(true);
        setUserLoading(true);
        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const newUser = { email, displayName: name };
                setUser(newUser);

                //Add user to db
                saveUserToDb(email, name, 'POST');

                // Send name to firebase
                updateProfile(auth.currentUser, {
                    displayName: name
                }).then(() => {
                    swal("Account Created Successfully!", "You can now continue exploring 500 Degrees Steakhouse", "success");
                    navigate('/')

                }).catch((error) => {

                });

            })
            .catch((error) => {
                console.log(error.message)
                if (error.message == 'Firebase: Error (auth/email-already-in-use).') {
                    swal("Invalid!", "An account already exists with this email'", "error");
                }
                if (error.message == 'Firebase: Password should be at least 6 characters (auth/weak-password).') {
                    swal("Invalid!", "Password should be at least 6 characters", "error");
                }
            })
            .finally(() => {
                setIsLoading(false);
                setUserLoading(false);
            });
    }

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            setIsLoading(true);
            setUserLoading(true);
            if (user) {
                setUser(user);
                getIdToken(user)
                    .then(token => {
                        localStorage.setItem('token', token)
                    })
                fetch(`https://gentle-tor-99938.herokuapp.com/users/${user.email}`)
                    .then(res => res.json())
                    .then(data => {
                        if (data.admin) {
                            setAdmin(true);
                        }
                    })
                    .then(() => {
                        setIsLoading(false);
                        setUserLoading(false);
                    })
            }
            else {
                setAdmin(false);
                setUser({})
                setIsLoading(false);
                setUserLoading(false);
            }

        });
    }, [auth, user.email])






    const signInWithGoogle = () => {
        setIsLoading(true);
        setUserLoading(true);
        signInWithPopup(auth, googleProvider)
            .then((result) => {
                const user = result.user;
                //Add user to db
                saveUserToDb(user.email, user.displayName, 'PUT');
                navigate('/')

            }).catch((error) => {
                if (error.message == 'Firebase: Error (auth/account-exists-with-different-credential).') {
                    swal("Invalid!", "An account already exists with this email'", "error");
                }
            })
            .finally(() => {
                setIsLoading(false);
                setUserLoading(false);
            });
    }

    const loginUser = (email, password) => {
        setIsLoading(true);
        setUserLoading(true);
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                toast.success(`Welcome back ${auth.currentUser.displayName.split(' ')[0]}`)
                navigate('/')
            })
            .catch((error) => {
                if (error.message === "Firebase: Error (auth/wrong-password).") {
                    swal("Invalid Password!", "Please check your email & password and then try again", "error");
                }
                else if (error.message === "Firebase: Error (auth/user-not-found).") {
                    swal("User Not Found!", "Please check your email & password and then try again", "warning");
                }
            })
            .finally(() => {
                setIsLoading(false);
                setUserLoading(false);
            });
    }
    const logOut = () => {
        signOut(auth).then(() => {
            // Sign-out successful.
            setAdmin(false);
            setUser({});
        }).catch((error) => {
            // An error happened.
        })
            .finally(() => {
                setIsLoading(false);
                setUserLoading(false);
            });
    }

    //Function to add users to database MONGO DB
    const saveUserToDb = (email, displayName, method) => {
        const user = { email, displayName };
        fetch('https://gentle-tor-99938.herokuapp.com/users', {
            method: method,
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(user)
        })
            .then()
    }



    return {
        admin,
        user,
        isLoading,
        userLoading,
        setIsLoading,
        registerUser,
        loginUser,
        signInWithGoogle,
        logOut,
        storage
    }

}


export default useFirebase;